import React, { useState } from "react";
import { useAuth } from "../../services/context/AuthContext";
import { useNavigate } from "react-router-dom";
import PasswordInput from "../utils/PasswordInput";

const SignupForm = ({ email, password, onSignupSuccess, onBack }) => {
  const [formData, setFormData] = useState({
    email: email || "",
    password: password || "",
    confirmEmail: "",
    cpf: "",
    telefone: "",
    nome: "",
    profissao: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { signup } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Normaliza o CPF removendo "." e "-"
    const normalizedValue =
      name === "cpf" ? value.replace(/[.-]/g, "") : value;

    setFormData({ ...formData, [name]: normalizedValue });
  };

  const handlePasswordChange = (value) => {
    setFormData({ ...formData, password: value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    // Validação da senha
    if (formData.password.length < 8) {
      setError("A senha deve ter no mínimo 8 caracteres.");
      return;
    }

    try {
      setLoading(true);
      const userId = await signup(formData, navigate);
      onSignupSuccess();
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container signup-container">
      <div className="login-header">
        <h2>Criar Conta</h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <form onSubmit={handleSignup}>
          <div>
            <label>Email:</label>
            <input
              className="email-readonly"
              type="email"
              name="email"
              value={formData.email}
              readOnly
            />
          </div>
          <div>
            <PasswordInput
              value={formData.password}
              onChange={handlePasswordChange}
            />
          </div>
          <div>
            <label>Nome:</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>CPF:</label>
            <input
              type="text"
              name="cpf"
              value={formData.cpf}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Telefone:</label>
            <input
              type="text"
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Profissão:</label>
            <input
              type="text"
              name="profissao"
              value={formData.profissao}
              onChange={handleChange}
            />
          </div>
          <div className="signup-btns">
            <button type="submit" disabled={loading}>
              {loading ? "Criando a conta..." : "Criar conta"}
            </button>
            <button type="button" onClick={onBack}>
              Voltar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignupForm;
